"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class UniqueIdStorage {
    constructor() {
        this.storage = {};
    }
    add(item) {
        this.getClassSet(item).add(item.data.id);
    }
    has(item) {
        return this.getClassSet(item).has(item.data.id);
    }
    getClassSet(item) {
        if (!this.storage[item.constructor.getModelName()]) {
            this.storage[item.constructor.getModelName()] = new Set();
        }
        return this.storage[item.constructor.getModelName()];
    }
}
exports.default = UniqueIdStorage;
//# sourceMappingURL=../../src/uniqueIdStorage.js.map